import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { ProvenanceRoutePage } from "../app/provenanceRoute";

export const Route = createFileRoute("/provenance")({
  component: ProvenanceRoute,
});

function ProvenanceRoute(): JSX.Element {
  const search = Route.useSearch();
  return <ProvenanceRoutePage search={search} />;
}
